<template>
    <div class="vm-remark-config">
      <div class="flex-box flex-align-items-center">
          <checkbox class="pointer baseline black-8" :class="{ black: has_plan_config_pre }" v-model="has_plan_config_pre">自定义信息收集</checkbox>
          <i class="afd afd-help ml8 gl-hover-text fwn black-3" v-tooltip.top="{content: '用户将在付款前填写此信息，你可以在「私信」和「收到的发电」中查看用户留下的信息。',trigger:browser_size == 'small' ? 'click':`hover`, classes:'look2'}"></i>
      </div>
      <div class="ml24" v-if="has_plan_config_pre">
        <div class="flex-box flex-align-items-baseline lh1 fs14">
          <span class="flex-shrink-0 mr16" style="width:44px;">标题</span>
          <input class="gl-input no-border pt16 pb16 fs14" type="text" placeholder="不填则默认为“留言”" v-model="remark_name_pre">
        </div>
        <div class="line"></div>
        <div class="flex-box flex-align-items-baseline lh1 fs14">
          <span class="flex-shrink-0 mr16" style="width:44px;">提示语</span>
          <input class="gl-input no-border pt16 pb16 fs14" type="text" placeholder="对需要收集的信息的补充说明" v-model="remark_placeholder_pre">
        </div>
        <div class="line"></div>
        <div v-if="is_show_required" class="flex-box flex-a-center lh1 mt16">
          <radio name="is_need_remark_placeholder" v-model="remark_required_pre" :value="0" :checked="remark_required_pre == 0" class="fs14">选填</radio>
          <radio name="is_need_remark_placeholder" v-model="remark_required_pre" :value="1" :checked="remark_required_pre == 1" class="ml40 fs14">必填</radio>
          <i class="afd afd-help ml8 gl-hover-text fwn black-3" v-tooltip.top="{content: '“必填”的付款信息收集有可能影响用户的付费，非必要时尽量不要选择“必填”',trigger:browser_size == 'small' ? 'click':`hover`, classes:'look2'}"></i>
        </div>
      </div>
    </div>
</template>

<script>

export default {
    name: 'remark-config',
    props: {
      has_plan_config: {
        default() {
          return 0;
        }
      },
      remark_name: {
        default() {
          return "";
        }
      },
      remark_placeholder: {
        default() {
          return "";
        }
      },
      remark_required: {
        default() {
          return 0;
        }
      },
      is_show_required:{
        default() {
          return 0;
        }
      }
    },
    watch:{
      has_plan_config_pre(v){
        this.$emit('update:has_plan_config', v ? 1 : 0)
      },
      remark_name_pre(v){
        this.$emit('update:remark_name', v)
      },
      remark_placeholder_pre(v){
        this.$emit('update:remark_placeholder', v)
      },
      remark_required_pre(v){
        this.$emit('update:remark_required', v)
      },
    },
    data() {
        return {
          has_plan_config_pre: this.has_plan_config,
          remark_name_pre: this.remark_name,
          remark_placeholder_pre: this.remark_placeholder,
          remark_required_pre: this.remark_required,
        };
    },
    mounted() {
    },
    methods: {
    }
};
</script>

<style lang="stylus" scoped>
.vm-remark-config{
    
}
</style>
